import { render, staticRenderFns } from "./vehicle-apps-details.vue?vue&type=template&id=16613226"
import script from "./vehicle-apps-details.vue?vue&type=script&lang=js"
export * from "./vehicle-apps-details.vue?vue&type=script&lang=js"
import style0 from "./vehicle-apps-details.vue?vue&type=style&index=0&id=16613226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports